import React from "react";
import MainLayout from "../MainLayout";
import PayStubDetail from "../../common/MainContent/Payroll/Paystubs/PaystubDetail";

const PayrollPaystubsDetailsPage = (props) => <MainLayout component={PayStubDetail} />;

export default PayrollPaystubsDetailsPage;
